// src/components/Eventos/LaneSortableItem.js
import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import SortableLaneRow from './SortableLaneRow';

const LaneSortableItem = ({
  laneNumber,
  athlete,
  onAddAthlete,
  onReplaceAthlete,
  additionalCells,
  rowStyle = {},        // Row style from parent
  cellStyle = {},       // Add cellStyle prop for table cells
  buttonStyle = {},     // Add buttonStyle prop
  typographyStyle = {}  // Add typographyStyle prop
}) => {
  const laneId = athlete ? String(athlete.idNumber) : `empty-${laneNumber}`;
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: laneId });
  const dndStyle = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  // Merge DnD styles with row style
  const mergedStyle = {
    ...rowStyle,
    ...dndStyle
  };

  return (
    <SortableLaneRow
      laneNumber={laneNumber}
      athlete={athlete}
      onAddAthlete={onAddAthlete}
      onReplaceAthlete={onReplaceAthlete}
      additionalCells={additionalCells}
      attributes={attributes}
      listeners={listeners}
      setNodeRef={setNodeRef}
      style={mergedStyle}
      cellStyle={cellStyle}         // Pass cellStyle to row
      buttonStyle={buttonStyle}     // Pass buttonStyle
      typographyStyle={typographyStyle} // Pass typography style
    />
  );
};

export default LaneSortableItem;